export const errorCodeToMessage = (
  code: number,
  systemMessage?: string
): string => {
  switch (code) {
  case -100:
    return 'Вы не авторизованы'
  case 404:
    return 'Не найден'
  case -300:
    return 'Ошибка при сохранении'
  case -301:
    return 'Ошибка при сохранении'
  case -350:
    return 'Указан неверный пароль'
  default:
    return `Код ошибки: ${code} Сообщение сервера: ${systemMessage}`
  }
}

export const ASSEMBLE_ERROR_ALREADY_TAKEN = 1
export const ASSEMBLE_ERROR_COUNT_IS_TOO_BIG = 2
export const ASSEMBLE_ERROR_WRONG_PRODUCT_STATUS = 3
